export default __webpack_public_path__ + "static/media/slider-prev.734fed14.svg";